export function communityQaListGet(page) {
	return {
    type: 'COMMUNITY_QA_LIST_GET',
		payload: {
			page: page,
		},
	}
}

export const communityQaStatisticsGet = (qaId) => {
	return {
		type: "COMMUNITY_QA_STATISTICS_GET",
		payload: {
			qaId: qaId,
		},
	}
}

export const communityQaStatisticsDel = (qaId) => {
	return {
		type: "COMMUNITY_QA_STATISTICS_SET",
		payload: {
			type: 'del',
			qaId: qaId,
		},
	}
}

export function communityQaStatisticsUserGet(qaId, answerText, page, callback) {
	return {
		type: "COMMUNITY_QA_STATISTICS_USER_GET",
		payload: {
			qaId: qaId,
			answerText: answerText,
			page: page,
		},
		callback: callback,
	}
}

export const communityQaStatisticsUserDel = (qaId, answerText) => {
	return {
		type: "COMMUNITY_QA_STATISTICS_USER_SET",
		payload: {
			type: 'del',
			qaId: qaId,
			answerText: answerText,
		},
	}
}

export function communityQaScrollposEdit(scrollpos) {
	return {
    type: 'COMMUNITY_QA_SCROLLPOS_SET',
		payload: {
			scrollpos: scrollpos,
		},
	}
}
